import { render, staticRenderFns } from "./SearchCandidates.vue?vue&type=template&id=3fa28d61&"
import script from "./SearchCandidates.vue?vue&type=script&lang=js&"
export * from "./SearchCandidates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports